module.exports = __webpack_public_path__ + "static/media/magicline-logo.972dd262.webp";